import React, { Component } from 'react';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import LandingBackground from 'assets/labs-landing-bg.png';
import LabsLogo from 'assets/labs-logo.png';

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 70px;
    z-index: 3000;
    background-color: #fff;
    height: 300px;
    background-color: #DEF0F9;
    background-image: url(${LandingBackground});
    background-position: left;
    background-repeat: repeat-x;
    background-size: contain;
    
    ${breakpoint('xs', 'lg')`
        margin-top: 60px;
        margin-bottom: 10px;
    `};
`;

const Logo = styled.img`
    width: 194px;
    height: 157px;
`;

class LabsTitleContainer extends Component {
    render() {
        return (
            <TitleWrapper admin={this.props.admin}>
                <Logo src={LabsLogo} />
            </TitleWrapper>

        );
    }
}


export default LabsTitleContainer;



// WEBPACK FOOTER //
// ./src/containers/labs/LabsTitleContainer.js